import React from 'react';
import DownloadDetailsSection from 'blocks/DownloadPage/components/DownloadDetailsSection';
import DownloadPreviewSection from '../../components/DownloadPreviewSection';
import { block } from '../../utils';
import AutogramReviewDetails from '../AutogramReviewDetails';
import DownloadShareDetails from '../DownloadShareDetails';
import useDownloadPageState from '../useDownloadPageState';

export interface DownloadPagePreviewSectionProps {
  aspectRatioName?: string;
  videoUrl?: string;
  canReclip: boolean;
}

const DownloadPagePreviewSection: React.FC<DownloadPagePreviewSectionProps> = ({
  aspectRatioName,
  videoUrl,
  canReclip,
}) => {
  const { createMethod, isAutogramReview } = useDownloadPageState();

  const isPodcastFeedAutoCreateEpisode =
    createMethod === 'podcastFeedAutoCreateEpisode';

  const downloadShareDetailsHidden =
    isAutogramReview && !isPodcastFeedAutoCreateEpisode;
  const showDownloadDetailsReclip =
    canReclip && !isPodcastFeedAutoCreateEpisode;
  const showAutogramReviewDetails =
    isAutogramReview && canReclip && !isPodcastFeedAutoCreateEpisode;

  return (
    <div className={block('contents')}>
      <DownloadPreviewSection
        aspectRatioName={aspectRatioName}
        videoUrl={videoUrl}
      />
      <DownloadDetailsSection>
        <DownloadShareDetails
          canReclip={showDownloadDetailsReclip}
          hidden={downloadShareDetailsHidden}
          isAutogramReviewDetailsActive={showAutogramReviewDetails}
          videoUrl={videoUrl}
        />
        <AutogramReviewDetails show={showAutogramReviewDetails} />
      </DownloadDetailsSection>
    </div>
  );
};

export default DownloadPagePreviewSection;
